export default __webpack_public_path__ + "897bdf61f781c1989e61080526ed102c.svg";